import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { VersionId } from '../model/index.tsx';
import type { UnresolvedIssuesCount, Version as RestVersion } from './types.tsx';

export const getVersionEndpointUrl = (versionId: VersionId): string =>
	`/rest/api/2/version/${versionId}`;

export const getVersionWithIssuesUrl = (versionId: VersionId): string =>
	`${getVersionEndpointUrl(versionId)}?expand=issuesstatus`;

export const getUnresolvedIssuesInVersionUrl = (versionId: VersionId): string =>
	`${getVersionEndpointUrl(versionId)}/unresolvedIssueCount`;

export const getVersion = (versionId: VersionId): Promise<RestVersion> =>
	fetchJson(getVersionWithIssuesUrl(versionId));

export const getUnresolvedIssuesCount = (versionId: VersionId): Promise<UnresolvedIssuesCount> =>
	fetchJson(getUnresolvedIssuesInVersionUrl(versionId));
